import { render, staticRenderFns } from "./FatAdded.vue?vue&type=template&id=e0520e46&scoped=true"
import script from "./FatAdded.vue?vue&type=script&lang=ts"
export * from "./FatAdded.vue?vue&type=script&lang=ts"
import style0 from "./FatAdded.vue?vue&type=style&index=0&id=e0520e46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0520e46",
  null
  
)

export default component.exports